// eslint-disable-next-line no-unused-vars
import React, { CSSProperties } from "react";
import _ from "lodash";
import XText from "./XText";

/**
 * 
 * @param {{
 *  style: CSSProperties,
 *  children: *
 * }} param0
 */
function XPropsInject({
  children = null,
  ...others
}){

  function renderChildren(_c){
    if(React.isValidElement(_c)){
      return React.cloneElement(_c, 
        {
          ...others,
          ..._c.props, 
        });
    }else{
      return _.map(_c, (o, i) => {
        if(!o){
          return null;
        }else if(_.isArray(o)){
          return _.map(o, (v, x) => {
            return renderChildren(v);
          });
        }else if(_.isString(o)){
          return <XText key={i}>{o}</XText>;
        }else if(!React.isValidElement(o)){
          console.log(o);
          //return o;
        }else{
          return React.cloneElement(o, 
            {
              ...others,
              ...o.props, 
              key: i
            });
        }
      });
    }
  }

  return renderChildren(children);
}

export default XPropsInject;